import { render, staticRenderFns } from "./VitalsDrawer.vue?vue&type=template&id=46cd0dce"
import script from "./VitalsDrawer.vue?vue&type=script&lang=js"
export * from "./VitalsDrawer.vue?vue&type=script&lang=js"
import style0 from "./VitalsDrawer.vue?vue&type=style&index=0&id=46cd0dce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports